import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useSelector } from "react-redux";
import { selectUser, flushUser } from "../redux/reducers/user";
import { store } from "../redux/store";

export const useAuth = () => {
  const user = useSelector(selectUser);

  const logOut = () => {
    const auth = getAuth();
    auth.signOut().then(() => {
      store.dispatch(flushUser());
    });
  };

  const signInWithGoogle = () => {
    console.log("signInWithGoogle");

    const provider = new GoogleAuthProvider();
    const auth = getAuth();
    signInWithPopup(auth, provider).catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      const email = error.email;
      const credential = GoogleAuthProvider.credentialFromError(error);
      console.log(errorCode, errorMessage, email, credential);
    });
  };

  return {
    user,
    signInWithGoogle,
    logOut,
  };
};
